<template>
  <Modal
    :id="'cmp-add-artist'"
    @cancelled="onCancel"
  >
    <template slot="header"> {{$t('add_artist')}} </template>
    <template slot="body">
      <div class="form-group">
        <TextField
          class="m1"
          :id="'artistName'"
          required
          v-bind="textFieldConfig"
          v-model="artistName"
          isModel
          :placeholder="$t('artist_name')"
          @valuechanged="onTextFieldValueChange"
          @validated="onValidation"
        ></TextField>
        <TextField
          class="m1"
          :id="'performanceType'"
          required
          v-bind="textFieldConfig"
          v-model="performanceType"
          isModel
          :placeholder="$t('performance')"
          @valuechanged="onTextFieldValueChange"
          @validated="onValidation"
        ></TextField>
        <TextField
          class="m1"
          :id="'url'"
          v-bind="textFieldConfig"
          v-model="url"
          isModel
          :placeholder="$t('url')"
          @valuechanged="onTextFieldValueChange"
          :showValidationIcons="false"
        ></TextField>
      </div>
    </template>
    <template slot="options">
      <button 
        class="dt-button s6" 
        @click.stop="onCancel"
      > {{$t('cancel')}} 
      </button>
      <button
        class="dt-button v1 with-ico s6"
        :class="{ disabled: !isFormValid }"
        :disabled="!isFormValid"
        @click.stop="onAddArtist"
      >
        <div class="dt-icon-container">
              <img src="static/icons/plus-white.svg" class="dt-icon v7" alt />
          </div>
          <div class="button-text">
              {{$t('add_new_artist')}}
          </div>
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";

export default {
  components: {
    Modal,
  },
  props: {

  },
  data: function() {
    return {
      artistName: '',
      performanceType: '',
      url: '',
      validationResult: {},
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        immediateValidation: true
      },
      // Mark: Data
    };
  },
  watch: {

  },
  computed: {
    artist: function() {
      return {
        name: this.artistName,
        performanceType: this.performanceType,
        url: this.url
      };
    },
    isFormValid: function() {
      return Object.values(this.validationResult).every(e => e.valid);
    },
  }, 
  methods: {
    onValidation: function(name, value) {
      this.$set(this.validationResult, name, value);
      console.log(this.validationResult);
    },
    onTextFieldValueChange: function(name, value) {
      console.log(name, value);
    },
    onCancel: function() {
      this.$emit('cancelled', true);
    },
    onAddArtist: function() {
      this.$emit('added', this.artist);
    }
    // Mark: Methods
  },
}


</script>

<style lang="scss" scoped>

// .ckeditor-container {
//   .ck-editor {
//     width: 100%;
//   }

// }


  .dt-input-box--container {
    // margin: 5px !important;
    // margin-left: 0px !important;
  }



</style>
